import { render, staticRenderFns } from "./tiaokuan.vue?vue&type=template&id=c4cd7b80&scoped=true&"
import script from "./tiaokuan.vue?vue&type=script&lang=js&"
export * from "./tiaokuan.vue?vue&type=script&lang=js&"
import style0 from "./tiaokuan.vue?vue&type=style&index=0&id=c4cd7b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cd7b80",
  null
  
)

export default component.exports